/** Biodata — document knowledge definition. Pure data. */
export default {
  id: 'biodata',
  name: 'Biodata',
  description: 'A structured personal profile document used for matrimonial and formal introductions.',
  purpose: 'Personal Profile & Introduction',
  recommendedSizes: [{ name: 'A4', width: 2480, height: 3508, unit: 'px' }],
  supportedOrientations: ['portrait'],
  supportsMultiplePages: true,
  supportsBleed: false,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: false,
  supportsTables: true,
  supportsPricing: false,
  supportsCTA: false,
  supportsOffers: false,
  supportsTimeline: true,
  supportsGallery: false,
  typicalSections: ['Photo', 'Personal Details', 'Education', 'Family Details', 'Contact'],
};
